import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './assets/locales/en/translation.json';
import translationHI from './assets/locales/hi/translation.json';
import translationTA from './assets/locales/ta/translation.json';

// the translations
const resources = {
    en: {
        translation: translationEN
    },
    hi: {
        translation: translationHI
    },
    ta: {
        translation: translationTA
    }
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: 'en',
        fallbackLng: 'en',

        // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
